import { Container, Grid } from "@mui/material";
import React from "react";

const HowItWorks = () => {
    return(
        <div className="OS---Ohmini-works py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    alignItems="center"
                    className="py-md-5"
                >
                    <Grid
                        xs={12}
                    >
                        <h2 className="OS---sectionHeading">How OhmniShiba Works</h2>
                    </Grid>
                    <Grid
                        xs={12}
                    >
                        <div className="OS---works-steps a">
                            <h6>1. sdfsfsd</h6>
                            <h3>ljsldfjsdlfjksdlk</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. 
                            </p>
                        </div>
                    </Grid>
                    <Grid   
                        xs={12}
                        className="text-left py-5"
                    >
                        <div className="OS---works-steps b ml-auto">
                            <h6>1. sdfsfsd</h6>
                            <h3>ljsldfjsdlfjksdlk</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. 
                            </p>
                        </div>
                    </Grid>
                    <Grid
                        xs={12}
                    >
                        <div className="OS---works-steps">
                            <h6>1. sdfsfsd</h6>
                            <h3>ljsldfjsdlfjksdlk</h3>
                            <p>
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. 
                            </p>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default HowItWorks;